import React, {useEffect, useState} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import {
    CustomHistoryIcon,
    CustomLogoMainIcon,
    CustomQuotesIcon,
    CustomSettingsIcon,
    Icon,
    Icons,
    LeftWrapper
} from "./sideMenuStyles";

const LeftSideMenu = () => {
    const navigate = useNavigate()
    const {pathname} = useLocation()
    const [selectedPage, setSelectedPage] = useState("quotes")

    useEffect(() => {
        const page = pathname.slice(1)
        setSelectedPage(page)
    }, [pathname])

    const handleQuotesIconClick = () => {
        navigate('/quotes')
        setSelectedPage("quotes")
    }
    const handleSettingsIconClick = () => {
        navigate('/settings')
        setSelectedPage("settings")

    }
    const handleHistoryIconClick = () => {
        navigate('/calculations')
        setSelectedPage("calculations")

    }

    return (
        <>
            <LeftWrapper>
                <Icons>
                    <Icon onClick={handleQuotesIconClick}>
                        <CustomLogoMainIcon/>
                    </Icon>
                    <Icon onClick={handleQuotesIconClick} className={selectedPage === "quotes" ? "selected" : ""}>
                        <CustomQuotesIcon/>
                    </Icon>
                    <Icon onClick={handleSettingsIconClick}
                          className={selectedPage === "settings" ? "selected" : ""}>
                        <CustomSettingsIcon/>
                    </Icon>
                    <Icon onClick={handleHistoryIconClick} className={selectedPage === "calculations" ? "selected" : ""}>
                        <CustomHistoryIcon/>
                    </Icon>
                </Icons>
            </LeftWrapper>
        </>
    );
};

export default LeftSideMenu;
